import m from 'mithril'
import { auth as authApi } from '../lib/api.js'

// Auth state — shared across components
let currentUser = null
let loading = false
let initialized = false
let error = null

export const authModel = {
  get user() { return currentUser },
  get loading() { return loading },
  get initialized() { return initialized },
  get error() { return error },
  get isLoggedIn() { return !!currentUser },

  async init() {
    if (initialized) return
    loading = true
    try {
      const session = await authApi.session()
      currentUser = session?.user || null
    } catch {
      currentUser = null
    } finally {
      initialized = true
      loading = false
      m.redraw()
    }
  },

  async login(email, password, projectInviteCode) {
    error = null
    try {
      const result = await authApi.login({ email, password })
      currentUser = result.user
      if (projectInviteCode) {
        m.route.set(`/join/${projectInviteCode}`)
      } else {
        m.route.set('/projects')
      }
    } catch (err) {
      error = err.message
      m.redraw()
    }
  },

  async signup(name, email, password, inviteCode, projectInviteCode) {
    error = null
    try {
      const body = { name, email, password }
      if (inviteCode) body.inviteCode = inviteCode
      if (projectInviteCode) body.projectInviteCode = projectInviteCode
      const result = await authApi.signup(body)
      currentUser = result.user
      if (projectInviteCode) {
        m.route.set(`/join/${projectInviteCode}`)
      } else {
        m.route.set('/projects')
      }
    } catch (err) {
      error = err.message
      m.redraw()
    }
  },

  async forgotPassword(email) {
    error = null
    try {
      await authApi.forgotPassword(email)
      return true
    } catch (err) {
      error = err.message
      m.redraw()
      return false
    }
  },

  async resetPassword(token, newPassword) {
    error = null
    try {
      await authApi.resetPassword(token, newPassword)
      m.route.set('/login')
      return true
    } catch (err) {
      error = err.message
      m.redraw()
      return false
    }
  },

  async logout() {
    await authApi.logout()
    currentUser = null
    m.route.set('/login')
  },

  clearError() {
    error = null
  },
}
